import { createTheme, PaletteColor } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    tertiary: PaletteColor;
  }
  interface PaletteOptions {
    tertiary?: PaletteColor;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    tertiary: true;
  }
}

const { palette } = createTheme();
export const theme = createTheme({
  // TODO: adjust palette with new design colors (MUI doesn't support CSS variables in palette)
  palette: {
    primary: palette.augmentColor({ color: { main: '#1f13f3' } }),
    secondary: palette.augmentColor({ color: { main: '#00cc9a' } }),
    tertiary: palette.augmentColor({ color: { main: '#c13af2', contrastText: '#fff' } }),
    // background: {
    //   default: 'var(--gentian-light-gray)',
    // },
  },
  typography: {
    fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    body1: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    body2: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    h1: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    h2: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    h3: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    h4: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    h5: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    h6: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    subtitle1: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    subtitle2: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    button: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    caption: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
    overline: {
      fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 687,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--gentian-white)',
          position: 'relative',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '8px',
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          pointerEvents: 'none',
        },
      },
    },
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       variants: [
    //         {
    //           props: { variant: 'contained', color: 'primary' },
    //           style: {
    //             // color: '#fff',
    //             // backgroundColor: 'var(--gentian-primary)',
    //           },
    //         },
    //         {
    //           props: { variant: 'contained', color: 'secondary' },
    //           style: {
    //             // color: '#fff',
    //             // backgroundColor: 'var(--gentian-primary)',
    //           },
    //         },
    //         {
    //           props: { variant: 'contained', color: 'tertiary' },
    //           style: {
    //             // color: '#fff',
    //             // backgroundColor: 'var(--gentian-tertiary)',
    //           },
    //         },
    //       ],
    //     },
    //   },
    // },
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root, .App': {
          minHeight: '100%',
          height: '100%',
        },
        body: {
          margin: 0,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'var(--gentian-white)',
          fontFamily: "'Schibsted Grotesk Medium', 'Geist', sans-serif",
        },
        code: {
          fontFamily: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
        },
        '.font--italic': {
          fontStyle: 'italic',
        },
        '.font__hairline': {
          fontWeight: 100,
        },
        '.font__thin': {
          fontWeight: 200,
        },
        '.font__light': {
          fontWeight: 300,
        },
        '.font__regular': {
          fontWeight: 400,
        },
        '.font__medium': {
          fontWeight: 500,
        },
        '.font__semibold': {
          fontWeight: 600,
        },
        '.font__bold': {
          fontWeight: 700,
        },
        '.font__heavy': {
          fontWeight: 800,
        },
        '.font__black': {
          fontWeight: 900,
        },
        ':fullscreen .hide-on-fullscreen, :fullscreen ~ .hide-on-fullscreen, :fullscreen + .hide-on-fullscreen':
          {
            display: 'none',
          },
        '.color--primary': {
          color: 'var(--gentian-primary) !important',
        },
        '.color--secondary': {
          color: 'var(--gentian-secondary) !important',
        },
        '.color--tertiary': {
          color: 'var(--gentian-tertiary) !important',
        },
        '.bg--primary': {
          backgroundColor: 'var(--gentian-primary) !important',
        },
        '.bg--secondary': {
          backgroundColor: 'var(--gentian-secondary) !important',
        },
        '.bg--tertiary': {
          backgroundColor: 'var(--gentian-tertiary) !important',
        },
        // Adding new color classes
        '.bg--eclipse-black': {
          backgroundColor: 'var(--eclipse-black) !important',
        },
        '.bg--dove-gray': {
          backgroundColor: 'var(--dove-gray) !important',
        },
        '.bg--gentian-blue': {
          backgroundColor: 'var(--gentian-blue) !important',
        },
        '.bg--sundrop-yellow': {
          backgroundColor: 'var(--sundrop-yellow) !important',
        },
        '.bg--orchid-purple': {
          backgroundColor: 'var(--orchid-purple) !important',
        },
        '.bg--clover-green': {
          backgroundColor: 'var(--clover-green) !important',
        },
        '.color--eclipse-black': {
          color: 'var(--eclipse-black) !important',
        },
        '.color--dove-gray': {
          color: 'var(--dove-gray) !important',
        },
        '.color--gentian-blue': {
          color: 'var(--gentian-blue) !important',
        },
        '.color--sundrop-yellow': {
          color: 'var(--sundrop-yellow) !important',
        },
        '.color--orchid-purple': {
          color: 'var(--orchid-purple) !important',
        },
        '.color--clover-green': {
          color: 'var(--clover-green) !important',
        },
      },
    },
  },
});
